import { isNull } from '@/utils/comparators'
import { MEMBERSHIP_BUCKET_TYPE, FREE_BUCKET_TYPE, TEST_BUCKET_TYPE, UNLIMITED_BUCKET_TYPE, DEAL_BUCKET_TYPE } from '@/utils/constants'
import {
  isGlobalUnlimited as productIsGlobalUnlimited,
  isGlobalLimited as productIsGlobalLimited,
  isUnlimited as productIsUnlimited,
  isUsUnlimited as productIsUsUnlimited,
  isLimited as productIsLimited,
  isSimPlan as productIsSimPlan,
  isWelcomeOffer as productIsWelcomeOffer,
  isRebin as productIsRebin,
  isMxUnlimited as productIsMxUnlimited
} from './productTypes'

/**
* Returns true if the bucket contains a Membership product.
* @param {object} bucket
*/
const isMembership = (bucket) => {
  return isNull(bucket) ? false : bucket.type === MEMBERSHIP_BUCKET_TYPE
}

/**
* Returns true if the bucket contains a Global Unlimited product.
* @param {object} bucket
*/
const isGlobalUnlimited = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsGlobalUnlimited(bucket.product)
  }
}

/**
* Returns true if the bucket contains a Global Limited product.
* @param {object} bucket
*/
const isGlobalLimited = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsGlobalLimited(bucket.product)
  }
}

/**
* Returns true if the bucket contains an Unlimited product.
* @param {object} bucket
*/
const isUnlimited = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsUnlimited(bucket.product)
  }
}

const isUsUnlimited = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsUsUnlimited(bucket.product)
  }
}

const isMxUnlimited = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsMxUnlimited(bucket.product)
  }
}

/**
* Returns true if the bucket contains a Limited product.
* @param {object} bucket
*/
const isLimited = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsLimited(bucket.product)
  }
}

/**
* Returns true if the bucket contains a SIM product.
* @param {object} bucket
*/
const isSimPlan = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsSimPlan(bucket.product)
  }
}

/**
* Returns true if the bucket contains a Welcome offer product.
* @param {object} bucket
*/
const isWelcomeOffer = (bucket) => {
  if (isNull(bucket)) {
    return false
  } else {
    return isNull(bucket.product) ? false : productIsWelcomeOffer(bucket.product)
  }
}

/**
* Returns true if the bucket contains a Bonus Minutes.
* @param {object} bucket
*/
const isBonusMinutes = (bucket) => {
  if (isNull(bucket) ||
      isNull(bucket.type) ||
      bucket.type === UNLIMITED_BUCKET_TYPE ||
      bucket.type === DEAL_BUCKET_TYPE) {
    return false
  }
  if (bucket.unit !== 'Minutes') {
    return false
  }
  if (productIsRebin(bucket.product) || productIsSimPlan(bucket.product)) {
    return false
  }

  return [FREE_BUCKET_TYPE, TEST_BUCKET_TYPE].indexOf(bucket.type) !== -1
}

const isFreeCredit = (bucket) => {
  if (isNull(bucket) || isNull(bucket.type)) {
    return false
  }

  return bucket.product.id === 3314
}
const isDeal = (bucket) => {
  if (isNull(bucket) || !bucket) {
    return false
  }
  if (isNull(bucket.type)) {
    return false
  }
  // bucket.product.categories[0] === 'Limited'
  // console.log(bucket, bucket.type, bucket.product.categories[0])
  return bucket.type === DEAL_BUCKET_TYPE && bucket.product && (bucket.product.categories[0] === 'Big' || bucket.product.categories[0] === 'Max')
}

export {
  isFreeCredit,
  isMembership,
  isGlobalUnlimited,
  isGlobalLimited,
  isUnlimited,
  isMxUnlimited,
  isUsUnlimited,
  isLimited,
  isSimPlan,
  isWelcomeOffer,
  isBonusMinutes,
  isDeal
}



// WEBPACK FOOTER //
// ./src/utils/bucketTypes.js